import { IconProps } from "./types";

export default function IcoVehicleKombi({
	color = "#9CA3AF",
	width = "22.5",
	height = "18"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 22 19"
			fill="none"
		>
			<g clipPath="url(#clip0_639_974)">
				<path
					d="M11 0.25C15.725 0.25 18.875 1.4875 18.875 3.0625V3.625V4.75C19.4973 4.75 20 5.25273 20 5.875V8.125C20 8.74727 19.4973 9.25 18.875 9.25V14.875C18.875 15.4973 18.3723 16 17.75 16V17.125C17.75 17.7473 17.2473 18.25 16.625 18.25H15.5C14.8777 18.25 14.375 17.7473 14.375 17.125V16H7.625V17.125C7.625 17.7473 7.12227 18.25 6.5 18.25H5.375C4.75273 18.25 4.25 17.7473 4.25 17.125V16C3.62773 16 3.125 15.4973 3.125 14.875V9.25C2.50273 9.25 2 8.74727 2 8.125V5.875C2 5.25273 2.50273 4.75 3.125 4.75V3.625V3.0625C3.125 1.4875 6.275 0.25 11 0.25ZM5.375 5.875V9.25C5.375 9.87227 5.87773 10.375 6.5 10.375H10.4375V4.75H6.5C5.87773 4.75 5.375 5.25273 5.375 5.875ZM11.5625 10.375H15.5C16.1223 10.375 16.625 9.87227 16.625 9.25V5.875C16.625 5.25273 16.1223 4.75 15.5 4.75H11.5625V10.375ZM5.9375 14.3125C6.23587 14.3125 6.52202 14.194 6.733 13.983C6.94397 13.772 7.0625 13.4859 7.0625 13.1875C7.0625 12.8891 6.94397 12.603 6.733 12.392C6.52202 12.181 6.23587 12.0625 5.9375 12.0625C5.63913 12.0625 5.35298 12.181 5.142 12.392C4.93103 12.603 4.8125 12.8891 4.8125 13.1875C4.8125 13.4859 4.93103 13.772 5.142 13.983C5.35298 14.194 5.63913 14.3125 5.9375 14.3125ZM16.0625 14.3125C16.3609 14.3125 16.647 14.194 16.858 13.983C17.069 13.772 17.1875 13.4859 17.1875 13.1875C17.1875 12.8891 17.069 12.603 16.858 12.392C16.647 12.181 16.3609 12.0625 16.0625 12.0625C15.7641 12.0625 15.478 12.181 15.267 12.392C15.056 12.603 14.9375 12.8891 14.9375 13.1875C14.9375 13.4859 15.056 13.772 15.267 13.983C15.478 14.194 15.7641 14.3125 16.0625 14.3125ZM14.375 3.0625C14.375 2.75312 14.1219 2.5 13.8125 2.5H8.1875C7.87813 2.5 7.625 2.75312 7.625 3.0625C7.625 3.37188 7.87813 3.625 8.1875 3.625H13.8125C14.1219 3.625 14.375 3.37188 14.375 3.0625Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_639_974">
					<path d="M0.875 0.25H21.125V18.25H0.875V0.25Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
